import { axios, URL_USER, URL_BASE } from "./_shared";

// =============================================
// ── Auth ──
// =============================================

export const changePassword = (password) => {
  return axios.post(`${URL_USER}updatePassword`, null, {
    params: { password },
  });
};

export const postUserLogin = ({ username, password, company = "" }) => {
  return axios.post(
    URL_USER + "login",
    { username, password, company },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    }
  );
};

export const getRefreshToken = () => {
  return axios.get(URL_USER + "refresh");
};

export const postSwitchCompany = (company) => {
  return axios.post(URL_USER + "switch-company", null, { params: { company } });
};

export const resetPassword = (userId, dni) => {
  return axios.post(`${URL_USER}reset-password/${userId}?dni=${dni}`);
};

/**
 * TOTP - Estado de acceso para un módulo específico
 */
export const getTotpStatus = (module) => {
    return axios.get(`${URL_BASE}api/v1/totp/status`, { params: { module } });
};

/**
 * TOTP - Generar QR para configurar Google Authenticator
 */
export const totpSetup = () => {
    return axios.post(`${URL_BASE}api/v1/totp/setup`);
};

/**
 * TOTP - Verificar código de 6 dígitos
 */
export const totpVerify = (code) => {
    return axios.post(`${URL_BASE}api/v1/totp/verify`, { code: parseInt(code) });
};
